module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioFinalExamen.6e169bd4.pdf";